var map = {
	"./small_thumb_avios_logo.png": 12014,
	"./small_thumb_avios_logo@2x.png": 89609,
	"./small_thumb_lux_logo.png": 54684,
	"./small_thumb_lux_logo@2x.png": 77184,
	"./small_thumb_miconex_logo.png": 1106,
	"./small_thumb_miconex_logo@2x.png": 71384,
	"./small_thumb_perkbox_logo.png": 88191,
	"./small_thumb_perkbox_logo@2x.png": 22416,
	"./small_thumb_stampfeet_logo.png": 78197,
	"./small_thumb_stampfeet_logo@2x.png": 27934,
	"./small_thumb_swipii_logo.png": 94734,
	"./small_thumb_swipii_logo@2x.png": 14541,
	"./small_thumb_topcashback_logo.png": 69599,
	"./small_thumb_topcashback_logo@2x.png": 20177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70843;